import { defineComponent as _defineComponent } from 'vue'
import { ModuleContentTitleTrend } from '@/@types/graphql-types';
import { useI18n } from '@/helpers/composables/useI18n';
import { formatRuntime } from '@/helpers/title-helper';
import { computed } from 'vue';

interface SingleRankingDisplayProps {
	trend: ModuleContentTitleTrend;
	rank: number;
	trendDifference: number;
	daysInTop1000?: number;
	withLogo?: boolean;
	withCondensed?: boolean;
	runtime?: number;
	releaseYear?: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SingleRankingDisplay',
  props: {
    trend: null,
    rank: null,
    trendDifference: null,
    daysInTop1000: null,
    withLogo: { type: Boolean, default: true },
    withCondensed: { type: Boolean, default: false },
    runtime: null,
    releaseYear: null
  },
  setup(__props: any) {

const props = __props as { trend: ModuleContentTitleTrend, rank: number, trendDifference: number, daysInTop1000?: number, withLogo: boolean, withCondensed: boolean, runtime?: number, releaseYear?: number }

const { t } = useI18n();

const ASSETS = `/${ASSETS_DIR}`;
const padNumber = (number: number) => {
	if (number.toString().length < 2) {
		return '0' + number;
	} else {
		return number;
	}
};
const trendDifference = computed(() => {
	if (props.trend === ModuleContentTitleTrend.Up) return `+${props.trendDifference}`;
	if (props.trend === ModuleContentTitleTrend.Stable) return '—';
	if (props.trend === ModuleContentTitleTrend.Down) return `${props.trendDifference}`;
});
const showArrow = computed(() => {
	return props.trend && !isNew.value;
});
const arrowClasses = computed(() => {
	if (!showArrow) {
		return null;
	}
	return {
		'arrow-container__arrow': !!props.trend,
		'arrow-container__arrow--up': props.trend === ModuleContentTitleTrend.Up,
		'arrow-container__arrow--stable': props.trend === ModuleContentTitleTrend.Stable,
		'arrow-container__arrow--down': props.trend === ModuleContentTitleTrend.Down,
	};
});
const isNew = computed(() => {
	return (
		(props.daysInTop1000 === 0 && props.rank <= 1000) ||
		props.trend === ModuleContentTitleTrend.New ||
		props.trendDifference >= 5000
	);
});
const showDetails = computed(() => {
	return props.runtime && props.releaseYear;
});
const runtime = computed(() => {
	const runtimeValue = props.runtime!;
	const { translationKey, minutes, hours } = formatRuntime(runtimeValue);

	return t(translationKey, { minutes, hours }) as string;
});

return { __sfc: true,t, props, ASSETS, padNumber, trendDifference, showArrow, arrowClasses, isNew, showDetails, runtime }
}

})